import React, { useEffect } from 'react';
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/contexts/AuthContext';

/**
 * Destino del enlace «Confirma tu correo» (`emailRedirectTo`).
 * Tras leer la sesión desde la URL (web, `detectSessionInUrl`), envía al paso 2 del registro.
 */
export function ComensalRegistroEmailRedirectPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (user) {
      navigate('/registro', { replace: true });
      return;
    }
    const t = setTimeout(() => navigate('/registro', { replace: true }), 5000);
    return () => clearTimeout(t);
  }, [user, loading, navigate]);

  return (
    <View style={styles.box}>
      <ActivityIndicator size="large" color="#A20000" />
      <Text style={styles.title}>Verificando tu correo…</Text>
      <Text style={styles.sub}>
        Si acabas de pulsar el enlace del correo, estamos entrando en tu cuenta. Te redirigimos al
        registro en un momento.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  box: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
    backgroundColor: '#ffffff',
  },
  title: {
    marginTop: 20,
    fontSize: 18,
    fontWeight: '700',
    color: '#030213',
    textAlign: 'center',
  },
  sub: {
    marginTop: 10,
    fontSize: 15,
    color: '#6b7280',
    textAlign: 'center',
    lineHeight: 22,
    maxWidth: 320,
  },
});
